import styled from 'academy-common-lib/utils/Styling';
import TrackViewAwardLink from '../../../components/TrackCard/TrackViewAwardLink';
import { useTrackAwardProgress } from '../../userProgress/userProgressQueries';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
const NoWrapTrackViewAwardLink = styled(TrackViewAwardLink).withConfig({
  displayName: "LearningContentCardAwardLink__NoWrapTrackViewAwardLink",
  componentId: "sc-1kq4k2w-0"
})(["white-space:nowrap;margin-left:18px;margin-bottom:1px;"]);
export const LearningContentCardAwardLink = ({
  trackId,
  use = 'on-dark'
}) => {
  const {
    award
  } = useTrackAwardProgress(trackId);
  if (!award || award.isExpired) return null;
  return /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(NoWrapTrackViewAwardLink, {
      award: award,
      certification: true,
      className: `track-card-simple__view-cert`,
      likeLink: true,
      size: 'small',
      trackId: trackId,
      use: use,
      useButton: false
    })
  });
};
export default LearningContentCardAwardLink;